import { lazyWithPreload } from '../../navigation';

export const HomeScreen = lazyWithPreload(() =>
    import('./HomeScreen').then((m) => ({ default: m.HomeScreen }))
);
